export default __webpack_public_path__ + "static/media/Flag.75b7822e.svg";